export default __webpack_public_path__ + "images/RecommendOffer1.png";